<template>
	<div style=" position: relative;">
		<div v-show="showChartInfo === false" >
			
			<div >
				<!-- <reportCharts/> -->
				<reportChartsItem :chartMap="chartMap1" @gotoChartsInfo="gotoChartsInfo"/>

				<reportChartsItem :chartMap="chartMap2" @gotoChartsInfo="gotoChartsInfo"/>

				<reportChartsItem :chartMap="chartMap3" @gotoChartsInfo="gotoChartsInfo"/>

				<!-- <reportChartsItem :chartMap="chartMap4" @gotoChartsInfo="gotoChartsInfo"/> -->
				
				<div class="list_row">
					<div class="list_title">
						<h3 class="list_title_left">後台報表：</h3>
						<el-link class="list_title_right" type="primary" @click="goEShopopee" >查詢更多</el-link>
						<div style="clear: both;"></div>
					</div>
					<div class="container">
				
						<el-button @click="goEshopopee8006">資產負債表</el-button>
				
						<el-button @click="goEshopopee8007">損益表</el-button>
					</div>
				</div>
			</div>
		</div>
		<div v-if="showChartInfo === true" style="height: 100%;width: 100%; top: 0px;background-color: white;"> 
		
			<reportChartsInfo :chartMap="seleChart"  @clickChartInfobackBtn="clickChartInfoBack"/>
		
		</div>

	</div>




</template>

<script setup>
	import {
		getCurrentInstance,
		onMounted,
		ref,
		toRef
	} from "vue";
	
	import reportChartsItem from "@/components/shopopee/report/reportChartsItem";
	import reportChartsInfo from "@/components/shopopee/report/reportChartsInfo";
    import {useUserinfo} from "@/stores/userinfo";
    import eshopopeeApi from "@/request/eshopopeeApi";
	import reportApi from "@/request/reportApi";
	import myUtil from "@/util/util";
	
	const userInfoRef = toRef(useUserinfo())

	const { proxy } = getCurrentInstance()

	//3d店鋪瀏覽數
	const chartMap1 = toRef({
		type:1,
		chartTitle: "3D店鋪瀏覽數據",
		chartTotalTilte: "3D店鋪瀏覽總量",
		chartTotalNum: 0,
		chartNewTilte: "當月瀏覽量",
		chartNewNum: 0
	})


	//郵件發送數據
	const chartMap2 = toRef({
		type:2,
		chartTitle: "郵件發送數據",
		chartTotalTilte: "郵件發送總量",
		chartTotalNum: 0,
		chartNewTilte: "當月郵件發送數",
		chartNewNum: 0
	})

	//訂單數
	const chartMap3 = toRef({
		type:3,
		chartTitle: "訂單數據",
		chartTotalTilte: "訂單總量",
		chartTotalNum: 0,
		chartNewTilte: "當月訂單數",
		chartNewNum: 0
	})


	//3d溝通數
	const chartMap4 = toRef({
		type:4,
		chartTitle: "溝通數",
		chartTotalTilte: "溝通數總量",
		chartTotalNum: 0,
		chartNewTilte: "當月溝通數",
		chartNewNum: 0
	})

	//熱門產品曝光數
	const chartMap5 = toRef({
		type:5,
		chartTitle: "熱門產品點擊數據",
		chartTotalTilte: "熱門產品點擊總量",
		chartTotalNum: 0,
		chartNewTilte: "當月熱門產品點擊數",
		chartNewNum: 0
	})
	const seleChart =toRef(chartMap1.value)
	
	
	const showChartInfo = ref(false)
	
	function clickChartInfoBack(){
		showChartInfo.value = false
	}
	
	//去數據詳情
	function gotoChartsInfo(obj){
		showChartInfo.value = true
		seleChart.value = obj
	}

	//郵件發送數（新增用戶）
	function getUserCount() {
		const request = reportApi.queryUserCount
		const params = request.getParams()
		request.send(params, (res) => {
			if (res.code == 200) {
				chartMap2.value.chartTotalNum = res.detail.allNum
				chartMap2.value.chartNewNum = res.detail.monNum
			}
		})
	}

	function getVisitCount(){
		const request = reportApi.queryVisitCount
		const params = request.getParams()
		params.CompanyCode = userInfoRef.value.companycode
		request.send(params, (res) => {
			if (res.code == 200) {
				chartMap1.value.chartTotalNum = res.detail.allNum
				chartMap1.value.chartNewNum = res.detail.monNum
			}
		})
	}


	//訂單數
	function getBOCount() {
		const request = eshopopeeApi.getBOCount
		const params = request.getParams()
		params.CompanyCode = userInfoRef.value.acccompanycode
		request.send(params, (res) => {
			console.log(res)
			if (res.code == 200) {
				chartMap3.value.chartTotalNum = res.allNum
				chartMap3.value.chartNewNum = res.monNum
			}
		})
	}


	onMounted(() => {
		// setInterval(function() {
		// 	chartMap1.value.chartTotalNum = 1200
		// 	chartMap1.value.chartNewNum = 200
		// }, 3000);
		getBOCount()
		getUserCount()
		getVisitCount()
	})
	
	function goEShopopee() {
		myUtil.confirmWarning(`將跳轉至 e-shopopee 網站，確定嗎？`, () => {
			const url = myUtil.generateEshopopeeManagerJumpUrl(userInfoRef.value.acccompanycode, userInfoRef.value.login, userInfoRef.value.password, "PrintMain.asp?shopForm=shopopee")
			// const url = "http://" + proxy.$EShopopeeUrl + "/ControlCenter/LoginCheck.asp?SelectCompanyCode=A&Email=admin&Password=888&redirectLink=PrintMain.asp"

			location.href = url
		})
	}
	function goEshopopee8006(){
		myUtil.confirmWarning(`將跳轉至 e-shopopee 網站，確定嗎？`, () => {
			const url = proxy.$SSL + "://" + proxy.$EShopopeeUrl + "/ControlCenter/LoginCheck.asp?SelectCompanyCode=" + userInfoRef.value.acccompanycode + "&Email=" + userInfoRef.value.login + "&Password=" + userInfoRef.value.password+"&redirectLink=PrintMain.asp%3FSQLEnquiryType=Acc%26ReID=8006"
			// const url = "http://" + proxy.$EShopopeeUrl + "/ControlCenter/LoginCheck.asp?SelectCompanyCode=A&Email=admin&Password=888&redirectLink=PrintMain.asp%3FSQLEnquiryType=Acc%26ReID=8006"
			location.href = url
		})
	}
	function goEshopopee8007(){
		myUtil.confirmWarning(`將跳轉至 e-shopopee 網站，確定嗎？`, () => {
			const url = proxy.$SSL + "://" + proxy.$EShopopeeUrl + "/ControlCenter/LoginCheck.asp?SelectCompanyCode=" + userInfoRef.value.acccompanycode + "&Email=" + userInfoRef.value.login + "&Password=" + userInfoRef.value.password+"&redirectLink=PrintMain.asp%3FSQLEnquiryType=Acc%26ReID=8007"
			// const url = "http://" + proxy.$EShopopeeUrl + "/ControlCenter/LoginCheck.asp?SelectCompanyCode=A&Email=admin&Password=888&redirectLink=PrintMain.asp%3FSQLEnquiryType=Acc%26ReID=8007"
			location.href = url
		})
	}
	
</script>

<style scoped>
	.container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.box {
		margin: 5px;
		/* 可选，用于添加两个盒子之间的间隔 */
		width: 40%;
		height: 200px;
		box-shadow: 5px 5px 10px #aaaaaa;
		border-radius: 8px;
	}

	.list_title {
		height: 70px;
	}

	.list_title_left {
		float: left;
	}

	.list_title_right {
		float: right;
		margin-top: 20px;
	}

	@media screen and (max-width: 520px) {

		/*小屏幕*/
		.list_row {
			margin: 10px 10px 10px 10px;
			padding: 8px 8px 8px 8px;
			border-radius: 10px;
			border: 1px solid;
			/* 设置边框宽度和样式 */
			border-color: #aaaaaa;
			/* 设置边框颜色为红色 */
		}
	}

	@media screen and (min-width: 520px) {

		.list_row {
			margin: 10px 50px 10px 50px;
			padding: 8px 8px 8px 8px;
			border-radius: 10px;
			border: 1px solid;
			/* 设置边框宽度和样式 */
			border-color: #aaaaaa;
			/* 设置边框颜色为红色 */
		}
	}
</style>